import { IEnhancedStore } from "@montana/models/dev";
import { ILocation } from "@montana/shared/map";

export function createLocation(store: IEnhancedStore): ILocation | null {
    if (!!store.geocodeLatitude && !!store.geocodeLongitude &&
        !store.geocodeLatitude?.includes('..') && !store.geocodeLongitude?.includes('..')) {
        const lat = parseFloat(store.geocodeLatitude);
        const lng = parseFloat(store.geocodeLongitude);
        return (!!lat && !!lng) ?
            {
                lat: parseFloat(store.geocodeLatitude!),
                lng: parseFloat(store.geocodeLongitude!)
            } : null;
    }

    return null;
}

export function getBoundsOfPins(pinsToFit: ILocation[]): google.maps.LatLngBoundsLiteral {
    const lats = pinsToFit.map((pin): number => pin.lat);
    const lngs = pinsToFit.map((pin): number => pin.lng);

    return {
        north: Math.min(...lats),
        south: Math.max(...lats),
        east: Math.max(...lngs),
        west: Math.min(...lngs),
    };
}

export const filterStoreInBounds = (stores: IEnhancedStore[], bounds: google.maps.LatLngBounds): IEnhancedStore[] => {
    if (!bounds) {
        return [];
    }

    const neLat = bounds.getNorthEast().lat();
    const neLng = bounds.getNorthEast().lng();
    const swLat = bounds.getSouthWest().lat();
    const swLng = bounds.getSouthWest().lng();

    return stores.filter(s => {
        const location = s.location;

        if (location) {
            return location.lat > swLat && location.lng > swLng && location.lat < neLat && location.lng < neLng
        } else {
            return false;
        }
    });
}